/**
 * The languages the product can be shown in. Mirrors
 * packages/backend/src/common/i18n/locales.ts — the API validates against its
 * copy, so a tag added here without the other is rejected on save.
 *
 * en-US is compiled into the bundle (locales/en.ts). Every other locale is
 * fetched from the API when a user picks it; a key with no stored value falls
 * back to the English string at render time.
 */
export const DEFAULT_LOCALE = 'en-US'

export const SUPPORTED_LOCALES = [
  'en-US',
  'en-GB',
  'fr-FR',
  'es-ES',
  'hi-IN',
  'de-DE',
  'ro-RO',
  'vi-VN',
] as const

export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number]

/** Shown in the picker in the language itself, so a user who cannot read the current one can still find theirs. */
export const LOCALE_LABELS: Record<SupportedLocale, string> = {
  'en-US': 'English (US)',
  'en-GB': 'English (UK)',
  'fr-FR': 'Français',
  'es-ES': 'Español',
  'hi-IN': 'हिन्दी',
  'de-DE': 'Deutsch',
  'ro-RO': 'Română',
  'vi-VN': 'Tiếng Việt',
}

export const isSupportedLocale = (value: unknown): value is SupportedLocale =>
  typeof value === 'string' && (SUPPORTED_LOCALES as readonly string[]).includes(value)
